// IMPORT MODULES
import $ from "jquery";
import SwapBackground from "@core/base/scripts/classes/swap-background/swap-background";


export default function moduleBackgroundImage(module) {
  const $container=$('.module-background',module);
  //
  $container.each((index,e)=>{
    const $that=$(e);
    const $bgImage=$('.module-background__image',$that);
    const swapBackground=new SwapBackground($bgImage);
    swapBackground.init();

  });
}
